const styleString = `
`

export function formatIframeString(iframeStr) {
  const retStr = iframeStr.includes('<head>')
    ? iframeStr.replace('<head>', `<head><base target="_blank">${styleString}`)
    : (iframeStr = `<head><base target="_blank">${styleString}</head>${iframeStr}`)
  return retStr
}
